export enum AnalyticsEventType {
  AGREED_TERMS_UPDATE = "AGREED_TERMS_UPDATE",
  CREATE_CLUSTER_START = "CREATE_CLUSTER_START",
  COMPLETED_CLUSTER_CREATION_STEP = "COMPLETED_CLUSTER_CREATION_STEP",
  CLUSTER_TYPE_SELECTED = "CLUSTER_TYPE_SELECTED",
  CLUSTER_SUPPLIER_SELECTED = "CLUSTER_SUPPLIER_SELECTED",
  CLUSTER_SECURITY_COMPLIANCE_SELECTED = "CLUSTER_SECURITY_COMPLIANCE_SELECTED",
  CLUSTER_LOCATIONS_SELECTED = "CLUSTER_LOCATIONS_SELECTED",
  CLUSTER_CONNECTIVITY_TIER_SELECTED = "CLUSTER_CONNECTIVITY_TIER_SELECTED",
  CLUSTER_PROCESSOR_SELECTED = "CLUSTER_PROCESSOR_SELECTED",
  CLUSTER_BASE_IMAGE_SELECTED = "CLUSTER_BASE_IMAGE_SELECTED",
  CLUSTER_QUANTITY_SELECTED = "CLUSTER_QUANTITY_SELECTED",
  CLUSTER_MASTER_NODE_SELECTED = "CLUSTER_MASTER_NODE_SELECTED",
  CLUSTER_ADDITIONAL_KUBERNETES_SERVICES_SELECTED = "CLUSTER_ADDITIONAL_KUBERNETES_SERVICES_SELECTED",
  CLUSTER_BARE_METAL_REQUEST_SELECTED = "CLUSTER_BARE_METAL_REQUEST_SELECTED",
  CLUSTER_DURATION_SELECTED = "CLUSTER_DURATION_SELECTED",
  CLUSTER_PROCESSOR_QUANTITY_SELECTED = "CLUSTER_PROCESSOR_QUANTITY_SELECTED",
  CLUSTER_PAYMENT_BUTTON_CLICKED = "CLUSTER_PAYMENT_BUTTON_CLICKED",
  CLUSTER_CANCEL_DEPLOYMENT_BUTTON_CLICKED = "CLUSTER_CANCEL_DEPLOYMENT_BUTTON_CLICKED",
  CLUSTER_DEPLOY_SELECTED = "CLUSTER_DEPLOY_SELECTED",
  CLUSTER_DEPLOYED_SUCCESSFULLY = "CLUSTER_DEPLOYED_SUCCESSFULLY",
  CLUSTER_PROCESSOR_FILTER_SELECTED = "CLUSTER_PROCESSOR_FILTER_SELECTED",
  CLUSTER_PROCESSOR_OPTION_SELECTED = "CLUSTER_PROCESSOR_OPTION_SELECTED",
  CLUSTER_LOCATION_SELECT_ALL_CLICKED = "CLUSTER_LOCATION_SELECT_ALL_CLICKED",
  DISCOVER_IO_INVENTORY_BUTTON_CLICK = "DISCOVER_IO_INVENTORY_BUTTON_CLICK",
  IO_INVENTORY_FILTER_CLICK = "IO_INVENTORY_FILTER_CLICK",
  STAKING_CONNECT_WALLET = "STAKING_CONNECT_WALLET",
  STAKING_STAKE_WITH_WRONG_WALLET = "STAKING_STAKE_WITH_WRONG_WALLET",
  STAKING_STAKE_PROCESS_STARTED = "STAKING_STAKE_PROCESS_STARTED",
  STAKING_STAKE_PROCESS_TRANSACTION_FAILED = "STAKING_STAKE_PROCESS_TRANSACTION_FAILED",
  STAKING_STAKE_PROCESS_MIDDLEWARE_FAILED = "STAKING_STAKE_PROCESS_MIDDLEWARE_FAILED",
  STAKING_STAKE_PROCESS_CANCELLED = "STAKING_STAKE_PROCESS_CANCELLED",
  STAKING_STAKE_PROCESS_TIMED_OUT = "STAKING_STAKE_PROCESS_TIMED_OUT",
  STAKING_STAKE_PROCESS_COMPLETED = "STAKING_STAKE_PROCESS_COMPLETED",
  STAKING_STAKE_PROCESS_CAPACITY_REACHED = "STAKING_STAKE_PROCESS_CAPACITY_REACHED",
  STAKING_UNSTAKE_WITH_WRONG_WALLET = "STAKING_UNSTAKE_WITH_WRONG_WALLET",
  STAKING_UNSTAKE_PROCESS_STARTED = "STAKING_UNSTAKE_PROCESS_STARTED",
  STAKING_UNSTAKE_PROCESS_TRANSACTION_FAILED = "STAKING_UNSTAKE_PROCESS_TRANSACTION_FAILED",
  STAKING_UNSTAKE_PROCESS_MIDDLEWARE_FAILED = "STAKING_UNSTAKE_PROCESS_MIDDLEWARE_FAILED",
  STAKING_UNSTAKE_PROCESS_CANCELLED = "STAKING_UNSTAKE_PROCESS_CANCELLED",
  STAKING_UNSTAKE_PROCESS_TIMED_OUT = "STAKING_UNSTAKE_PROCESS_TIMED_OUT",
  STAKING_UNSTAKE_PROCESS_COMPLETED = "STAKING_UNSTAKE_PROCESS_COMPLETED",
  STAKING_UNSTAKE_PROCESS_CAPACITY_REACHED = "STAKING_UNSTAKE_PROCESS_CAPACITY_REACHED",
  STAKING_WITHDRAW_WITH_WRONG_WALLET = "STAKING_WITHDRAW_WITH_WRONG_WALLET",
  STAKING_WITHDRAW_PROCESS_STARTED = "STAKING_WITHDRAW_PROCESS_STARTED",
  STAKING_WITHDRAW_PROCESS_TRANSACTION_FAILED = "STAKING_WITHDRAW_PROCESS_TRANSACTION_FAILED",
  STAKING_WITHDRAW_PROCESS_MIDDLEWARE_FAILED = "STAKING_WITHDRAW_PROCESS_MIDDLEWARE_FAILED",
  STAKING_WITHDRAW_PROCESS_CANCELLED = "STAKING_WITHDRAW_PROCESS_CANCELLED",
  STAKING_WITHDRAW_PROCESS_TIMED_OUT = "STAKING_WITHDRAW_PROCESS_TIMED_OUT",
  STAKING_WITHDRAW_PROCESS_COMPLETED = "STAKING_WITHDRAW_PROCESS_COMPLETED",
  STAKING_WITHDRAW_PROCESS_CAPACITY_REACHED = "STAKING_WITHDRAW_PROCESS_CAPACITY_REACHED",
  TAB_OPENED = "TAB_OPENED",
  MODEL_CLICKED = "MODEL_CLICKED",
  MODEL_SEARCHED = "MODEL_SEARCHED",
  ALL_MODELS_CLICKED = "ALL_MODELS_CLICKED",
  READ_LICENSE_CLICKED = "READ_LICENSE_CLICKED",
  DUMMY_QUERY_CLICKED = "DUMMY_QUERY_CLICKED",
  PROMPT_TYPED = "PROMPT_TYPED",
  TEXT_COPIED = "TEXT_COPIED",
  AGENT_SEARCHED = "AGENT_SEARCHED",
  NEW_CHAT_OPENED = "NEW_CHAT_OPENED",
  AGENT_CLICKED = "AGENT_CLICKED",
  INSTALL_CLICKED = "INSTALL_CLICKED",
  CODE_COPIED = "CODE_COPIED",
  AGENT_CLOSED = "AGENT_CLOSED",
  DOCS_CLICKED = "DOCS_CLICKED",
  SUPPORT_CLICKED = "SUPPORT_CLICKED",
  SECRET_KEY_INITIATED = "SECRET_KEY_INITIATED",
  FORM_OPENED = "FORM_OPENED",
  FORM_FILLED = "FORM_FILLED",
  SECRET_KEY_CREATED = "SECRET_KEY_CREATED",
  SECRET_KEY_EDITING_INITIATED = "SECRET_KEY_EDITING_INITIATED",
  SECRET_KEY_EDITED = "SECRET_KEY_EDITED",
  SECRET_KEY_REVOKE_INITIATED = "SECRET_KEY_REVOKE_INITIATED",
  SECRET_KEY_REVOKED = "SECRET_KEY_REVOKED",
  SIGNED_IN = "SIGNED_IN",
  SIGN_UP_CLICKED = "SIGN_UP_CLICKED",
  SIGN_UP_INITIATED = "SIGN_UP_INITIATED",
  USER_CREATED = "USER_CREATED",
  RETURN_CLICKED = "RETURN_CLICKED",
  SKIP_THIS_STEP_CLICKED = "SKIP_THIS_STEP_CLICKED",
  PROVIDER_SELECTED = "PROVIDER_SELECTED",
  WALLET_CONNECTION_INITIATED = "WALLET_CONNECTION_INITIATED",
  WALLET_CONNECTED_SUCCESSFULLY = "WALLET_CONNECTED_SUCCESSFULLY",
  BACK_CLICKED = "BACK_CLICKED",
  UPLOAD_FILE_INITIATED = "UPLOAD_FILE_INITIATED",
  FILE_UPLOADED = "FILE_UPLOADED",
  FILE_INFO_CLICKED = "FILE_INFO_CLICKED",
  FILE_DOWNLOAD_CLICKED = "FILE_DOWNLOAD_CLICKED",
  FILE_DELETED = "FILE_DELETED",
  DELETE_ALL_INITIATED = "DELETE_ALL_INITIATED",
  DELETE_ALL_CONFIRMED = "DELETE_ALL_CONFIRMED",
  SEARCH_SETTINGS_OPENED = "SEARCH_SETTINGS_OPENED",
  VECTOR_SEARCH_TOGGLE = "VECTOR_SEARCH_TOGGLE",
  HYBRID_SEARCH_TOGGLE = "HYBRID_SEARCH_TOGGLE",
  GRAPH_SEARCH_TOGGLE = "GRAPH_SEARCH_TOGGLE",
  VECTOR_RESULT_LIMIT = "VECTOR_RESULT_LIMIT",
  VECTOR_INDEX_UPDATED = "VECTOR_INDEX_UPDATED",
  VECTOR_PROBES_ADDED = "VECTOR_PROBES_ADDED",
  VECTOR_EF_ADDED = "VECTOR_EF_ADDED",
  HYBRID_TEXT_WEIGHT_ADDED = "HYBRID_TEXT_WEIGHT_ADDED",
  HYBRID_SEMANTIC_ADDED = "HYBRID_SEMANTIC_ADDED",
  HYBRID_TEXT_LIMIT_ADDED = "HYBRID_TEXT_LIMIT_ADDED",
  HYBRID_RRF_ADDED = "HYBRID_RRF_ADDED",
  RAG_TEMPERATURE_UPDATED = "RAG_TEMPERATURE_UPDATED",
  RAG_TOP_P_UPDATED = "RAG_TOP_P_UPDATED",
  RAG_MAX_TOKENS_UPDATED = "RAG_MAX_TOKENS_UPDATED",
  DUMMY_QUERY_USED = "DUMMY_QUERY_USED",
  CHAT_CLEAR_INITIATED = "CHAT_CLEAR_INITIATED",
  CHAT_CLEAR_RESPONSE = "CHAT_CLEAR_RESPONSE",
  MESSAGE_SENT = "MESSAGE_SENT",
  RESULT_COPIED = "RESULT_COPIED",
  CONTACT_SERVICES_CLICKED = "CONTACT_SERVICES_CLICKED",
  TRENDING_DEVICE_CLICKED = "TRENDING_DEVICE_CLICKED",
  COUNTRY_CLICKED = "COUNTRY_CLICKED",
  EXPLORE_TAB_CLICKED = "EXPLORE_TAB_CLICKED",
  BLOCK_REWARD_CLICKED = "BLOCK_REWARD_CLICKED",
  CLUSTER_CLICKED = "CLUSTER_CLICKED",
  IO_INVENTORY_CLICKED = "IO_INVENTORY_CLICKED",
  INVENTORY_FILTERED = "INVENTORY_FILTERED",
  REQUEST_CLUSTER_CLICKED = "REQUEST_CLUSTER_CLICKED",
  DEVICE_CLICKED = "DEVICE_CLICKED",
  // IO Credits
  REQUEST_CREDIT_CLICKED = "REQUEST_CREDIT_CLICKED",
  REQUEST_CREDIT_SUBMITTED = "REQUEST_CREDIT_SUBMITTED",
  REQUEST_WITHDRAWAL_CLICKED = "REQUEST_WITHDRAWAL_CLICKED",
  REQUEST_WITHDRAWAL_SUBMITTED = "REQUEST_WITHDRAWAL_SUBMITTED",
  USE_CLICKED = "USE_CLICKED",
  CLAIM_REWARDS_CLICKED = "CLAIM_REWARDS_CLICKED",
  START_EARNING_CLICKED = "START_EARNING_CLICKED",
  CREDIT_REFUNDED = "CREDIT_REFUNDED",
  CREDIT_WITHDRAWAL_SUCCESSFULL = "CREDIT_WITHDRAWAL_SUCCESSFULL"
}
